<template>
  <div class="user" v-loading="loading">
    <back />
    <div class="">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="nickName" placeholder="请输入用户名称" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="userCode" placeholder="请输入用户编号" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-select class="s_input" v-model="gender" placeholder="请选择用户性别" clearable @change="onSearch">
          <el-option v-for="item in genderOptions" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="nickName" label="用户昵称"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="gender" label="用户性别">
            <template slot-scope="scope">
              <span v-if="scope.row.gender == 0">女</span>
              <span v-if="scope.row.gender == 1">男</span>
              <span v-if="scope.row.gender == 2">未知</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="phoneNum" label="电话号码">
            <template slot-scope="scope">
              <span>{{ scope.row.phoneNum || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="createdTime" label="注册时间"></el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      nickName: "",//姓名
      userCode: "",//用户编号
      gender: "",//性别
      tableData: [],
      genderOptions: [
        { value: "0", label: "女" },
        { value: "1", label: "男" },
        { value: "2", label: "未知" },
      ],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getRequestList()

  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.userBellowUser, {
          params: {
            userId: this.$route.query.userId,
            gender: this.gender || null,
            nickName: this.nickName || null,
            userCode: this.userCode || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.user {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
</style>
